import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import EmailIcon from 'components/ReusableComponents/Icons/Email'
import PassKeyIcon from 'components/ReusableComponents/Icons/Passkey'
import useCopyText from 'hooks/useCopyText'
import moment from 'moment'
import {
  getSubsidiaryPmsUserKindLabel,
  isHotelContactPmsUser
} from '../../subsidiaryPmsUserKind'

import styles from '../../Hotel.module.scss'

const PMSUserCard = ({ user, setSelectedPMSUser, setShowPmsUserFTPDialog }) => {
  const copy = useCopyText()
  const kindLabel = getSubsidiaryPmsUserKindLabel(user)
  const isHotelContact = isHotelContactPmsUser(user)

  const handleShowCredentials = () => {
    setSelectedPMSUser(user)
    setShowPmsUserFTPDialog(true)
  }

  return (
    <div key={user.id} className={styles.pmsUserContainer}>
      <div className={styles.pmsUserTitleRow}>
        <div
          className={styles.pmsUserTitle}
          data-tip={`${moment(user.birthDate).format('MMM DD, YYYY')}`}
        >
          {user.firstName} {user.lastName}
        </div>
        <span
          className={`${styles.pmsUserKindTag} ${
            isHotelContact ? styles.pmsUserKindTagHotelContact : styles.pmsUserKindTagPmsIntegration
          }`}
        >
          {kindLabel}
        </span>
      </div>
      <div className={styles.pmsUserBar}>
        <div className={styles.pmsEmail}>
          <EmailIcon width={21} height={21} fill="#A8ADB2" />
          <p className={styles.pmsEmailText}>{user.email}</p>
        </div>
        <button
          className={styles.pmsEmailCopyButton}
          onClick={() => user.email && copy(user.email)}
        >
          <CopyIcon />
        </button>
      </div>
      {user.isFtpSupport && (
        <div className={styles.pmsUserBar}>
          <div className={styles.pmsEmail}>
            <PassKeyIcon width={21} height={21} fill="#A8ADB2" />
            <p
              className={styles.showCredentialsText}
              onClick={() => handleShowCredentials(user)}
            >
              Show FTP credentials
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default PMSUserCard
